import type { Template } from "@/types";

export const LA_04_H4_V0: Template[] = [
{
    id: "la-04-h4v0-01",
    name: "LA 01 - H4V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 134, width: 313, height: 208, rotation: 0, imageRotation: 0 },
            { id: "2", x: 320, y: 134, width: 313, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 641, y: 134, width: 313, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 961, y: 134, width: 313, height: 208, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h4v0-02",
    name: "LA 02 - H4V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 46, y: 40, width: 294, height: 195, rotation: 0, imageRotation: 0 },
            { id: "2", x: 340, y: 243, width: 294, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 642, y: 243, width: 293, height: 194, rotation: 0, imageRotation: 0 },
            { id: "4", x: 935, y: 40, width: 293, height: 195, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h4v0-03",
    name: "LA 03 - H4V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 158, y: 47, width: 320, height: 188, rotation: 0, imageRotation: 0 },
            { id: "2", x: 158, y: 242, width: 320, height: 187, rotation: 0, imageRotation: 0 },
            { id: "3", x: 795, y: 47, width: 320, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 795, y: 242, width: 320, height: 187, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h4v0-04",
    name: "LA 04 - H4V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 40, y: 227, width: 276, height: 184, rotation: 0, imageRotation: 0 },
            { id: "2", x: 323, y: 227, width: 276, height: 184, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 227, width: 276, height: 184, rotation: 0, imageRotation: 0 },
            { id: "4", x: 964, y: 227, width: 276, height: 184, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h4v0-05",
    name: "LA 05 - H4V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 214, width: 313, height: 208, rotation: 0, imageRotation: 0 },
            { id: "2", x: 320, y: 214, width: 313, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 641, y: 214, width: 313, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 961, y: 214, width: 313, height: 208, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h4v0-06",
    name: "LA 06 - H4V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 44, y: 47, width: 286, height: 188, rotation: 0, imageRotation: 0 },
            { id: "2", x: 44, y: 241, width: 286, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 943, y: 47, width: 286, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 943, y: 241, width: 286, height: 188, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h4v0-07",
    name: "LA 07 - H4V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 40, y: 65, width: 276, height: 184, rotation: 0, imageRotation: 0 },
            { id: "2", x: 323, y: 65, width: 276, height: 184, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 65, width: 276, height: 184, rotation: 0, imageRotation: 0 },
            { id: "4", x: 964, y: 65, width: 276, height: 184, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h4v0-08",
    name: "LA 08 - H4V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 208, y: 36, width: 220, height: 130, rotation: 0, imageRotation: 0 },
            { id: "2", x: 208, y: 173, width: 220, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 208, y: 309, width: 220, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 695, y: 65, width: 520, height: 344, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h4v0-09",
    name: "LA 09 - H4V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 97, y: 192, width: 424, height: 238, rotation: 0, imageRotation: 0 },
            { id: "2", x: 97, y: 48, width: 208, height: 138, rotation: 0, imageRotation: 0 },
            { id: "3", x: 313, y: 48, width: 208, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 678, y: 67, width: 557, height: 342, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h4v0-10",
    name: "LA 10 - H4V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 43, y: 46, width: 645, height: 383, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1012, y: 46, width: 216, height: 123, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1012, y: 176, width: 216, height: 123, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1012, y: 307, width: 216, height: 122, rotation: 0, imageRotation: 0 }
    ],
}
];